import { useLocation } from 'react-router';
import { TabList as AriaTabList, Tab } from 'react-aria-components';
import type { TabListProps } from 'react-aria-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboardList } from '@fortawesome/free-solid-svg-icons/faClipboardList';
import { faUserAlt } from '@fortawesome/free-solid-svg-icons/faUserAlt';
import { faHistory } from '@fortawesome/free-solid-svg-icons/faHistory';
import { faTruck } from '@fortawesome/free-solid-svg-icons/faTruck';
import { faHandHoldingUsd } from '@fortawesome/free-solid-svg-icons/faHandHoldingUsd';
import { faFile } from '@fortawesome/free-solid-svg-icons/faFile';
import { faPhotoVideo } from '@fortawesome/free-solid-svg-icons/faPhotoVideo';
import { faShareAlt } from '@fortawesome/free-solid-svg-icons/faShareAlt';
import OrderReducedIcon from 'components/custom-icon/OrderReducedIcon';
import MessageIcon from 'components/custom-icon/MessageIcon';
import { DetailTabsEnum } from '@pages/orders/detail/tabs-menu/DetailTabsEnum';
import { useHasPermission } from '@hooks/has-permission/useHasPermission';
import { AppRolesEnum } from '@features/routing/appRolesEnum';
import { NavigateRoutesEnum } from '@features/routing/routesEnum';



export const TabList = <T extends object>(props: TabListProps<T>) => {

	const location = useLocation();
	const hasPermission = useHasPermission();

	return (
		<AriaTabList aria-label='Detail menu' {...props}>
			
			<Tab id={DetailTabsEnum.basicOverview} isDisabled={!hasPermission(AppRolesEnum.orders_Read)}>
				<FontAwesomeIcon icon={faClipboardList} />
			</Tab>
			
			<Tab id={DetailTabsEnum.orderChanges} isDisabled={true}>
				<OrderReducedIcon />
			</Tab>

			<Tab id={DetailTabsEnum.customerInfo} isDisabled={!hasPermission(AppRolesEnum.customers_Read)}>
				<FontAwesomeIcon icon={faUserAlt} />
			</Tab>

			<Tab id={DetailTabsEnum.orderHistory} isDisabled={true}>
				<FontAwesomeIcon icon={faHistory} />
			</Tab>

			<Tab id={DetailTabsEnum.orderTimeline} isDisabled={location.pathname !== NavigateRoutesEnum.orders || !hasPermission(AppRolesEnum.orders_Read)}>
				<FontAwesomeIcon icon={faTruck} />
			</Tab>

			<Tab id={DetailTabsEnum.orderFinance} isDisabled={true}>
				<FontAwesomeIcon icon={faHandHoldingUsd} />
			</Tab>

			<Tab id={DetailTabsEnum.orderDocuments} isDisabled={true}>
				<FontAwesomeIcon icon={faFile} />
			</Tab>

			<Tab id={DetailTabsEnum.orderMedia} isDisabled={true}>
				<FontAwesomeIcon icon={faPhotoVideo} />
			</Tab>

			<Tab id={DetailTabsEnum.orderSms} isDisabled={true}>
				<MessageIcon />
			</Tab>

			<Tab id={DetailTabsEnum.exports} isDisabled={true}>
				<FontAwesomeIcon icon={faShareAlt} />
			</Tab>
		</AriaTabList>
	)
}